import type { Stripe, StripeCardNumberElement } from '@stripe/stripe-js';
import { useContainer } from '~/composables/useContainer';
import { DependencyInjectId } from '@@/package/const/DependencyInjectId';
import type SubscriptionApi from '@@/package/apis/subscription/SubscriptionApi';

export function useStripeSetupIntent() {
    const subscriptionApi = useContainer<SubscriptionApi>(DependencyInjectId.SubscriptionApi);

    async function confirmStripeSetup(
        stripe: Stripe,
        cardEl: StripeCardNumberElement,
        cardHolderName: string
    ): Promise<{ paymentMethodId: string; setupIntentId: string }> {
        const response = await subscriptionApi.getStripeSetupIntent();
        const { clientSecret, setupIntentId } = response.data;

        const { setupIntent, error } = await stripe.confirmCardSetup(clientSecret, {
            payment_method: {
                card: cardEl,
                billing_details: { name: cardHolderName },
            },
        });
        if (error) throw new Error(error.message);

        const paymentMethodId = typeof setupIntent!.payment_method === 'string'
            ? setupIntent!.payment_method
            : setupIntent!.payment_method?.id;
        if (!paymentMethodId) throw new Error('Setup failed: no payment method');

        return { paymentMethodId, setupIntentId };
    }

    return { confirmStripeSetup };
}
